<script setup lang="ts">
const props = defineProps<{ 
    title: string,
    desc?: string,
    btnTxt?: string,
}>();
const emit = defineEmits<{ (event: 'btnClick'): void }>();

function handleOnClick() {
    emit('btnClick');
};
</script>

<template>
    <SectionsBase class="cta-v2-background">
        <div class="container flex-center perspective-normal">
            <div class="cta-v2-card">
                <div>
                    <span class="h2 block text-center">{{ props.title }}</span>
                    <p v-if="props.desc" class="text-body1-semibold mt-6 text-center">{{ props.desc }}</p>
                </div>
                <Button
                    :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                    size="Large"
                    variant="white"
                    pill
                    @click="handleOnClick"
                >
                    {{ props.btnTxt ? props.btnTxt : 'درخواست مشاوره رایگان' }}
                </Button>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.cta-v2-background {
  @apply
  relative bg-gray-50 text-white
}
.cta-v2-background::before {
  @apply
  content-[''] absolute w-full h-full top-0 right-0 bg-[url('/svg/new/backgrounds/mesh-09.svg')] bg-no-repeat 
  bg-bottom lg:bg-size-[100%_auto]
}

.cta-v2-card {
    animation: card-tilt linear both;
    animation-timeline: view();
    animation-range: entry 0% cover 50%;
    background: linear-gradient(139.35deg, #00204E 8.8%, #003D97 32.61%, #003D97 43.48%, #012C6C 88.8%);
    @apply
    relative w-full max-w-212.5 flex justify-center items-center flex-col gap-8 rounded-3xl px-10 py-16 
    z-1 overflow-hidden origin-bottom transition-transform duration-100
}
.cta-v2-card::before {
    @apply
    content-[''] absolute w-full h-full bg-[url('/svg/new/backgrounds/mesh-09.svg')] -z-2 top-0 right-0 bg-no-repeat 
    bg-size-[500%_auto] lg:bg-size-[200%_auto] bg-center
}
.cta-v2-card::after {
    @apply
    content-['V'] absolute text-white/30 text-[70rem] lg:text-[100rem] blur-2xl lg:blur-3xl -z-1
}

@media only screen and (min-width: 1024px) {
    @keyframes card-tilt {
        from { transform: rotateX(65deg) }
        to   { transform: rotateX(0deg) }
    }   
}
</style>